'use strict';

exports.__esModule = true;
exports.loaders = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _doctifyGlobalRedux = require('doctify-global-redux');

var _doctifyGlobalRedux2 = _interopRequireDefault(_doctifyGlobalRedux);

var _blogBanner = require('../actions/blog-banner');

var _blogBanner2 = _interopRequireDefault(_blogBanner);

var _landingPages = require('../actions/landing-pages');

var _landingPages2 = _interopRequireDefault(_landingPages);

var _reviewCarousel = require('../actions/review-carousel');

var _reviewCarousel2 = _interopRequireDefault(_reviewCarousel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _globalRedux$globalAc = _doctifyGlobalRedux2.default.globalActions.ListingsActions,
    getSpecialties = _globalRedux$globalAc.getSpecialties,
    getConditions = _globalRedux$globalAc.getConditions,
    getProcedures = _globalRedux$globalAc.getProcedures,
    getTreatmentGroups = _globalRedux$globalAc.getTreatmentGroups,
    getInsurers = _globalRedux$globalAc.getInsurers,
    getHealthChecks = _globalRedux$globalAc.getHealthChecks,
    getSpecialists = _globalRedux$globalAc.getSpecialists,
    getPractices = _globalRedux$globalAc.getPractices;
var getPosts = _blogBanner2.default.getPosts,
    getBlogMedia = _blogBanner2.default.getBlogMedia,
    getBlogPostCategories = _blogBanner2.default.getBlogPostCategories,
    getAuthorInfo = _blogBanner2.default.getAuthorInfo;
var getKeywordLandingPages = _landingPages2.default.getKeywordLandingPages;
var getReviews = _reviewCarousel2.default.getReviews,
    getSpecialistImage = _reviewCarousel2.default.getSpecialistImage;


var reviewCalls = function reviewCalls(xhrAdapter) {
	return function (dispatch) {
		return getReviews(xhrAdapter)(dispatch).then(function (reviews) {
			return _promise2.default.all(((reviews || {}).reviews || []).map(function (review) {
				return getSpecialistImage(review.specialist.id, xhrAdapter)(dispatch);
			}));
		});
	};
};

var blogBannerCalls = function blogBannerCalls(xhrAdapter) {
	return function (dispatch) {
		return getPosts(xhrAdapter)(dispatch).then(function (posts) {
			return _promise2.default.all([].concat((posts || []).map(function (post) {
				return getBlogMedia(post.featured_media, xhrAdapter)(dispatch);
			}), (posts || []).map(function (post) {
				return getBlogPostCategories(post.id, xhrAdapter)(dispatch);
			}), (posts || []).map(function (post) {
				return getAuthorInfo(post.author, xhrAdapter)(dispatch);
			})));
		});
	};
};

var loaders = exports.loaders = [{
	key: 'listings.insurers',
	action: getInsurers
}, {
	key: 'listings.specialties',
	action: getSpecialties
}, {
	key: 'listings.conditions',
	action: getConditions
}, {
	key: 'listings.procedures',
	action: getProcedures
}, {
	key: 'listings.specialists',
	action: getSpecialists
}];


// WEBPACK FOOTER //
// ./components/home-page/lib/utils/loaders.js